
function CalcVolumeDistribution(totalPages, maxContentPages,
                                selectedPosts,
                                pageCounts, pageEstimates)
{
  var remainingPages = totalPages
  var maxPages = maxContentPages
  var targetVolumes = parseInt((remainingPages+maxPages-1)/maxPages)
  var targetPageCount = remainingPages / targetVolumes

  var zeroAccumulator = { pages: 0, posts: 0, busy: 0, pids: [] }
  var accumulator = Object.assign({},zeroAccumulator)
  var averagePostLength = totalPages / selectedPosts.length
  var volumes = []
  
  function pushAccumulator() {
    remainingPages -= accumulator.pages
    targetVolumes = parseInt((remainingPages+maxPages-1)/maxPages)
    if (remainingPages > 0) {
      targetPageCount = remainingPages / targetVolumes
    }
  
    accumulator.pages = parseInt(accumulator.pages)
    volumes.push(accumulator)
    accumulator = Object.assign({},zeroAccumulator)
    accumulator.pids = []
    console.log('VOL #',volumes.length,' tgt->',targetPageCount,'/',targetVolumes, volumes.map(v=>v.pages))
  }
  
  for (var i=0; i<selectedPosts.length; i++) {
    var pid = selectedPosts[i]
    var postLength = pageCounts[pid]!=undefined ? pageCounts[pid] : pageEstimates[pid]
    if (postLength === undefined) {
      postLength = averagePostLength
    }

    if (accumulator.pages + postLength > maxPages) {
      pushAccumulator()
    }
    
    var postBusy = pageCounts[pid]!==undefined ? 0 : pageEstimates[pid]!==undefined ? 1 : 1000
    accumulator.pages += postLength
    accumulator.posts += 1
    accumulator.busy += postBusy
    accumulator.pids.push(pid)
    
    if (accumulator.pages >= targetPageCount) {
      pushAccumulator()
    }    
  }
  if (accumulator.pages) {
    pushAccumulator()
  }
  return volumes
}

export {
  CalcVolumeDistribution,
}



// WEBPACK FOOTER //
// ./src/components/voluminator_utils.js